// type ValidatorFunc = { [key: string]: (v: string) => string | null }
// type ValidationResult = { [key: string]: string }

// eslint-disable-next-line import/prefer-default-export
export class ObjectHelpers {
    static removeFalsy(object: any): any {
        const defaultValue: { [key: string]: any } = {};
        // eslint-disable-next-line no-return-assign
        return Object.entries(object).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), defaultValue);
    }

    static removeNullAndUndefined(object: any): any {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return Object.fromEntries(Object.entries(object).filter(([_, v]) => v != null));
    }
}
